export default __webpack_public_path__ + "static/media/NISSAN.83a201e2.png";